import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/site/Motion";
import { useDiagnostic } from "@/context/DiagnosticContext";

export default function CTABand({ content }) {
  const c = content?.cta || {};
  const { openDiagnostic } = useDiagnostic();

  return (
    <section className="px-6 md:px-12 lg:px-24 py-16 md:py-24 border-t border-border">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-ink text-stone-50 px-8 md:px-16 py-16 md:py-24">
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-white/5 blur-2xl" aria-hidden />
          <div className="relative max-w-2xl">
            <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-[1.05]">{c.heading}</h2>
            <p className="font-sans text-base md:text-lg text-stone-300 mt-6 max-w-xl">{c.subtitle}</p>
            <motion.button
              data-testid="cta-diagnostico"
              onClick={() => openDiagnostic()}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="group mt-10 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-stone-50 text-ink font-sans text-sm md:text-base hover:bg-white transition-colors duration-300"
            >
              {c.button}
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-300" />
            </motion.button>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
